import React, { Component } from 'react';

import Auxi from '../../../hoc/Auxi/Auxi';
import classes from './CreateAccountInline.module.css';
import EmailRegisterContainer from '../../../containers/Auth/EmailRegisterInner/EmailRegisterInnerContainer';
import strings from '../../../assets/localization';
import Button from '../../UI/Button/Button';
import Spinner from '../../UI/Spinner/Spinner';
import AlertError from '../AlertError/AlertError';

export default class CreateAccountInline extends Component {
  renderSpinner = () => {
    return <div className={classes.SpinnerWrapper}><Spinner /></div>;
  }

  render () {
    // console.log('Create Account Inner render Component:', this.props, this.state);
    return (
      <Auxi>
        <div className={classes.CreateAccountInline}>
          <div className={classes.StepsWrapper}>
            <div className={classes.StepsTitle}>{strings.StepsTitle}</div>
            <div className={classes.PageControllerWrapper}>
              <Button
                style={{borderTop: '0.125rem solid var(--navigation-background)', borderBottom: '2.25rem solid var(--navigation-background)', minWidth: '0', background: this.props.step === 1 ? 'var(--primary-button-background)' : 'var(--secondary-button-background)'}}
                clicked={() => this.props.jumpToStep(1)}
                disabled={this.props.step < 2}
                ariaLabel={strings.step+' 1'}
                noScale
              />
              <Button
                style={{borderTop: '0.125rem solid var(--navigation-background)', borderBottom: '2.25rem solid var(--navigation-background)', minWidth: '0', background: this.props.step === 2 ? 'var(--primary-button-background)' : 'var(--secondary-button-background)'}}
                clicked={() => this.props.jumpToStep(2)}
                disabled={this.props.step < 3}
                ariaLabel={strings.step+' 2'}
                noScale
              />
              <Button
                style={{borderTop: '0.125rem solid var(--navigation-background)', borderBottom: '2.25rem solid var(--navigation-background)', minWidth: '0', background: this.props.step === 3 ? 'var(--primary-button-background)' : 'var(--secondary-button-background)'}}
                clicked={() => this.props.jumpToStep(3)}
                disabled={this.props.step < 4}
                ariaLabel={strings.step+' 3'}
                noScale
              />
              <Button
                style={{borderTop: '0.125rem solid var(--navigation-background)', borderBottom: '2.25rem solid var(--navigation-background)', minWidth: '0', background: this.props.step === 4 ? 'var(--primary-button-background)' : 'var(--secondary-button-background)'}}
                clicked={() => this.props.jumpToStep(4)}
                disabled={this.props.step < 5}
                ariaLabel={strings.step+' 4'}
                noScale
              />
              <Button
                style={{borderTop: '0.125rem solid var(--navigation-background)', borderBottom: '2.25rem solid var(--navigation-background)', minWidth: '0', background: this.props.step === 5 ? 'var(--primary-button-background)' : 'var(--secondary-button-background)'}}
                clicked={() => this.props.jumpToStep(5)}
                disabled={this.props.step <= 5}
                ariaLabel={strings.step+' 5'}
                noScale
              />
              {this.props.showSpinner ? this.renderSpinner() : null}
            </div>
            <EmailRegisterContainer
              isLandscape={this.props.isLandscape}
              step={this.props.step}
              goToStep={this.props.goToStep}
              toggleMinHeight={this.props.toggleMinHeight}
            />
          </div>
          {this.props.showErrorAlert ? <AlertError dismissAlert={this.props.dismissAlert} errorMessage={this.props.errorAlertMessage} /> : null}
        </div>
      </Auxi>
    );
  }
}
